import React from 'react';
import { useGetBwgsurveyQuery } from './BWGSurveySlice';
import { useNavigate } from 'react-router-dom';

const BWGSurvey = () => {
        const navigate = useNavigate();

    const {
        data: BWGSurvey
    } = useGetBwgsurveyQuery();
    console.log("BWGSurvey", BWGSurvey);

    return (
        <>
            <div className='container-fluid '>
                <div className='row'>
                    <div className='col-3 p-3'></div>
                </div>
                {/* <div className="Card_table_data w-25">
                <button type="button" className="Add_button bg-left-navabr w-100 text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffsearch" aria-controls="depOffsearch"> Search</button>

                <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffsearch" aria-labelledby="depOffsearch">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvas1Label">Search</h5>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ></button>
                    </div>
                    <select
                        aria-label="Default select example"
                        className=' form-select'
                        name='status'
                        onChange={handleChange}
                        value={searchParamsLocal.status}
                    >
                        <option value={""}>--</option>
                        {
                            statusList && statusList.length > 0 && statusList.map((item, index) => {
                                return <option key={index} value={item}>{item}</option>
                            })
                        }
                    </select>
                    <button className="bg-left-navabr mt-2 text-light  btn btn-secondary" onClick={handleSearch} data-bs-dismiss="offcanvas" aria-label="Close" >Data Search</button>
                    <button className="bg-left-navabr mt-2 text-light  btn btn-secondary" onClick={handleReset} data-bs-dismiss="offcanvas" aria-label="Close" >Reset</button>                </div>
            </div>
             */}
                <div>
                    <div className='box_overflow col'>
                        {/* {isComplainListLoading && (
                        <p>Loading...</p>
                    )} */}

                        {/* {isComplainListError && (
                        <p>Error: {complainListError}</p>
                    )} */}

                        {/* {!isComplainListLoading && !isComplainListError && ( */}
                        <table className='border table p-2'>
                            <thead className='mobile-hidden'>
                                <tr className='bg-left-navabr '>
                                    <th className='text-light'>#</th>
                                    <th className='text-light'>Property Name</th>
                                    <th className='text-light'>Number</th>
                                    <th className='text-light'>Contact Name</th>
                                    <th className='text-light'>address</th>
                                </tr>
                            </thead>
                            <tbody className='mobile-hidden'>
                                {BWGSurvey?.map((item, index) => (
                                    <tr className='listData' key={item.id}  onClick={() => (navigate(`/b2g/BWGSurveyDetail/${item?.id}`))}>
                                        <td>{index + 1}</td>
                                        <td>{item?.property_name}</td>
                                        <td>{item?.contact_number}</td>
                                        <td>{item?.contact_name}</td>
                                        <td>{item?.address}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {/* )} */}
                    </div>

                </div>

            </div>
        </>
    );
}

export default BWGSurvey;
